/* DVR - BUSCA DA VITRINE DO VESTUARIO (Claude, 22/10/2026).

   Este arquivo NAO substitui o dvr-vitrine2.js: ele entra depois e assume so a
   caixa de busca que aquele motor desenha. Nenhuma linha do motor foi tocada;
   tirando a linha que carrega este arquivo, tudo volta a ser como era.

   OS TRES DEFEITOS QUE ELE RESOLVE

   1) A BUSCA NAO SAIA DA COLECAO ESCOLHIDA.
      O filtro de estilo (as bolinhas Botanico, Mistico, ...) esconde cartao
      pelo atributo `hidden`. A busca esconde por `data-dv2-fora`. Como nenhum
      dos dois limpa o outro, os dois valiam ao mesmo tempo: quem estava em
      Fofinhos e escrevia "gato" procurava gato DENTRO de Fofinhos, e a grade
      dizia "0 estampas" mesmo existindo cinco gatos na linha.
      Agora, no instante em que a pessoa escreve, a busca passa a valer na linha
      inteira: o atalho "Todas" acende e os cartoes escondidos pelo estilo
      voltam. A busca ganha do filtro, que e o que a pessoa espera.

   2) A BUSCA SO OLHAVA A PALAVRA EXATA, EM PORTUGUES, NA ORDEM ESCRITA.
      Era um `indexOf` do texto inteiro digitado dentro do nome do cartao.
      "Forest Circle" nao aparecia em "floresta"; "gato chapeu" nao aparecia
      porque o nome e "Gato Chapeu Cogumelo" com outra ordem; "cogumelos" nao
      achava "cogumelo".
      Agora cada palavra vale por si (todas tem que bater, em qualquer ordem),
      singular e plural se encontram, e existe um dicionario de equivalencias:
      floresta = forest = mata = bosque, gato = cat = felino, micelio =
      mycelium = raizes, psicodelico = mistico = magico, e assim por diante.

   3) "ESTAMPA NO PEITO" NAO FAZIA NADA.
      Peito, frente e costas nao sao estampas: sao POSICOES, e todas as pecas
      tem as tres. Procurar por elas como texto nunca ia dar certo. O mesmo
      vale para cor. Agora essas palavras saem da busca e viram ACAO: a grade
      inteira se repinta na posicao (ou na cor) pedida. Quem escreve "estampa
      no peito" ve as 80 estampas no peito.

   ONDE ESTA O DICIONARIO: na lista SIN, logo abaixo. Para a busca aprender uma
   palavra nova, acrescente ela na linha do grupo certo. E o unico lugar.
   O LIMITE DELE, que e importante saber: o dicionario liga palavra a palavra,
   entao ele so acha o que ja esta escrito em algum lugar do cartao (nome da
   estampa, colecao de estilo, tag do produto, endereco). Palavra que descreve
   um desenho que nenhum texto menciona nao tem como aparecer. Para essas, o
   caminho certo e TAG no produto na Shopify: a tag ja entra no cartao pelo
   tema e vira palavra de busca aqui sem mexer em arquivo nenhum. */
(function () {
'use strict';

/* ---------- grupos de palavras equivalentes ---------- */
var SIN = [
  ['floresta', 'forest', 'mata', 'mato', 'bosque', 'selva', 'clareira', 'arvore', 'arvores', 'woods', 'natureza'],
  ['cogumelo', 'cogumelos', 'mushroom', 'mushrooms', 'mush', 'fungo', 'fungos', 'fungica', 'fungico', 'fungi', 'shroom'],
  ['amanita', 'amanitas', 'muscaria', 'bolinhas', 'pintas', 'poa', 'mario'],
  ['micelio', 'micelial', 'miceliar', 'mycelium', 'rede', 'raiz', 'raizes', 'esporo', 'esporos', 'esporada'],
  ['gato', 'gatos', 'gata', 'cat', 'cats', 'felino', 'bichano'],
  ['sapo', 'sapos', 'frog', 'perereca'],
  ['raposa', 'raposas', 'fox'],
  ['gnomo', 'gnomos', 'duende', 'duendes', 'anao', 'gnome'],
  ['fada', 'fadas', 'fairy', 'encantada', 'encantado'],
  ['fantasma', 'fantasmas', 'ghost', 'assombrado', 'halloween'],
  ['buda', 'budda', 'buddha', 'zen', 'meditacao', 'universo', 'universos', 'cosmos'],
  ['deus', 'deuses', 'divino', 'divindade'],
  ['lua', 'luar', 'lunar', 'moon', 'noite', 'noturno'],
  ['estrela', 'estrelas', 'star', 'stars', 'ceu', 'galaxia'],
  ['sol', 'solar', 'sun'],
  ['flor', 'flores', 'flower', 'floral', 'florida', 'campo', 'jardim', 'canteiro', 'planta', 'plantas', 'folha', 'folhas', 'vegetal'],
  ['inseto', 'insetos', 'bug', 'bugs', 'besouro', 'borboleta', 'bicho', 'bichos', 'animal', 'animais', 'fauna'],
  ['passaro', 'passaros', 'ave', 'bird', 'coruja'],
  ['coracao', 'coracoes', 'heart', 'amor', 'love'],
  ['olho', 'olhos', 'olhar', 'olhares', 'eye', 'eyes', 'vigilia', 'guardiao', 'observa'],
  ['chapeu', 'chapeus', 'hat', 'hats'],
  ['outono', 'autumn', 'fall'],
  ['agua', 'lago', 'rio', 'espelho', 'reflexo', 'chuva'],
  ['neon', 'fluorescente', 'brilha', 'brilhante', 'glow', 'luz', 'brilho', 'escuridao'],
  ['prisma', 'arco', 'iris', 'rainbow', 'colorido', 'colorida', 'cores', 'aquarela'],
  ['abstrato', 'abstrata', 'organica', 'organico', 'forma', 'formas', 'geometrico', 'geometrica'],
  ['retro', 'vintage', 'antigo', 'antiga', 'setenta', 'oldschool', 'nostalgia'],
  ['botanico', 'botanica', 'botanical', 'ilustracao', 'herbario', 'herbologia', 'catalogo', 'guia', 'prancha', 'naturalista', 'cientifico', 'cientifica', 'desenho', 'enciclopedia', 'especies'],
  ['harry', 'potter', 'hogwarts', 'herbologia', 'bruxo', 'bruxa', 'bruxaria', 'feitico'],
  ['mistico', 'mistica', 'misticos', 'magia', 'magico', 'magica', 'magic', 'magical', 'espiritual', 'sagrado', 'psicodelico', 'psicodelica', 'psicodelicos', 'psicodelia', 'trippy', 'psychedelic', 'lisergico', 'alucinogeno', 'surreal', 'onirico', 'sonho'],
  ['fofo', 'fofa', 'fofinho', 'fofinhos', 'cute', 'kawaii', 'meigo', 'pelucia', 'fofura', 'gracinha'],
  ['musica', 'banjo', 'violao', 'serenata', 'instrumento', 'canta', 'cantoria'],
  ['tricot', 'tricoteiro', 'croche', 'agulha', 'novelo'],
  ['aventura', 'aventureiro', 'andarilho', 'viagem', 'viajante', 'vagam', 'vagar', 'caminho', 'passo', 'passos', 'trilha', 'mochila', 'explorador', 'tolkien', 'errante'],
  ['tempo', 'aneis', 'anos', 'relogio'],
  ['circulo', 'circle', 'roda', 'mandala', 'redondo', 'ciclo', 'anel', 'aneis'],
  ['gigante', 'grande', 'enorme'],
  ['frase', 'escrito', 'texto', 'letras', 'palavra', 'palavras', 'tipografia', 'lettering'],
  ['cha', 'chazinho', 'bule', 'xicara', 'tea'],
  ['selo', 'marca', 'logo', 'logotipo', 'emblema', 'brasao', 'distintivo'],
  ['menina', 'garota', 'mulher', 'girl', 'moca', 'feminina', 'feminino', 'boneca'],
  ['nanquim', 'tinta', 'traco', 'minimalista', 'simples', 'monocromatico'],
  ['caca', 'cacador', 'coleta', 'colher', 'foraging', 'cesta', 'temporada'],
  ['clube', 'turma', 'grupo', 'familia', 'juntos', 'amigos', 'vizinhos', 'comunidade']
];

/* posicao da estampa: nao e assunto de busca, e acao */
var POS = {
  frente: 'Frente', frontal: 'Frente', frontais: 'Frente',
  peito: 'Peito', peitoral: 'Peito', peitinho: 'Peito',
  costas: 'Costas', costa: 'Costas', atras: 'Costas', tras: 'Costas'
};
/* cor: idem. os nomes batem com as chaves da paleta do motor */
var COR = {
  branco: 'branco', branca: 'branco', brancas: 'branco', brancos: 'branco',
  bege: 'bege', creme: 'bege', cru: 'bege', areia: 'bege',
  rosa: 'rosa', rose: 'rosa',
  cinza: 'cinza', mescla: 'cinza', cinzento: 'cinza',
  verde: 'verde', musgo: 'verde', oliva: 'verde',
  vermelho: 'vermelho', vermelha: 'vermelho', rubro: 'vermelho',
  marrom: 'marrom', cafe: 'marrom', chocolate: 'marrom', terra: 'marrom',
  roxo: 'roxo', roxa: 'roxo', lilas: 'roxo', violeta: 'roxo', purpura: 'roxo',
  preto: 'preto', preta: 'preto', negro: 'preto', escuro: 'preto', escura: 'preto'
};
/* palavras que a pessoa escreve por educacao e nao filtram nada */
var VAZIAS = {
  estampa: 1, estampas: 1, camisa: 1, camiseta: 1, camisetas: 1, blusa: 1, blusas: 1,
  peca: 1, pecas: 1, modelo: 1, com: 1, sem: 1, de: 1, da: 1, do: 1, das: 1, dos: 1,
  no: 1, na: 1, nos: 1, nas: 1, em: 1, um: 1, uma: 1, uns: 1, umas: 1, o: 1, a: 1,
  os: 1, as: 1, e: 1, ou: 1, para: 1, pra: 1, por: 1, que: 1, tem: 1, ter: 1,
  quero: 1, queria: 1, gostaria: 1, procuro: 1, tipo: 1, mais: 1, meu: 1, minha: 1,
  unissex: 1, baby: 1, look: 1, oversized: 1
};

/* montados na hora, e nao escritos como escape de unicode, de proposito: o
   caminho que grava arquivo no tema transforma escape em caractere literal, e
   caractere invisivel dentro de expressao e pedido de dor de cabeca. Por isso
   tambem nao existe nenhuma barra invertida neste arquivo. */
var NBSP = String.fromCharCode(160);
var MARCAS = new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g');

function pad(t) {
  t = String(t || '').split(NBSP).join(' ');
  try { t = t.normalize('NFD').replace(MARCAS, ''); } catch (e) {}
  return t.toLowerCase();
}
function fatia(q) {
  return pad(q).replace(/[^a-z0-9]+/g, ' ').split(' ').filter(function (p) { return p; });
}

/* o texto onde a palavra e procurada: nome do cartao, endereco da peca e as
   colecoes e tags que o tema ja escreve em data-dv-keys. */
function indiceDe(c) {
  if (c.dvrbIdx) return c.dvrbIdx;
  var nome = c.querySelector('.dv-nome');
  var chaves = (c.getAttribute('data-dv-keys') || '').replace(/[a-z]:/g, ' ');
  var href = c.getAttribute('data-dv2-h') || c.getAttribute('href') || '';
  var i = href.indexOf('/products/');
  if (i >= 0) href = href.slice(i + 10);
  var t = (nome ? nome.textContent : '') + ' ' + chaves + ' ' + href;
  c.dvrbIdx = ' ' + pad(t).replace(/[^a-z0-9]+/g, ' ') + ' ';
  return c.dvrbIdx;
}

/* as formas aceitaveis de uma palavra: em `p` ela mesma e o singular/plural
   dela, em `s` o grupo de equivalencia a que ela pertence. */
var CACHE_ALT = {};
function formas(t) {
  if (CACHE_ALT[t]) return CACHE_ALT[t];
  var proprio = [t], base = t, sin = [], i, j;
  if (t.length > 3 && t.charAt(t.length - 1) === 's') { base = t.slice(0, -1); proprio.push(base); }
  else if (t.length > 2) proprio.push(t + 's');
  for (i = 0; i < SIN.length; i++) {
    if (SIN[i].indexOf(t) !== -1 || SIN[i].indexOf(base) !== -1) {
      for (j = 0; j < SIN[i].length; j++) {
        if (proprio.indexOf(SIN[i][j]) === -1 && sin.indexOf(SIN[i][j]) === -1) sin.push(SIN[i][j]);
      }
    }
  }
  CACHE_ALT[t] = { p: proprio, s: sin };
  return CACHE_ALT[t];
}
/* O QUE A PESSOA ESCREVEU vale como comeco de palavra, para a grade ir
   filtrando conforme ela digita: "gat" ja acha "gato". O QUE O DICIONARIO
   ACRESCENTOU vale so como palavra inteira. Essa diferenca nao e capricho:
   no primeiro teste, "gato" trouxe tambem o Catalogo da Floresta, porque o
   sinonimo "cat" aparece dentro de "catalogo". O indice de cada cartao e
   guardado entre espacos justamente para esta conta. */
function bate(idx, t) {
  var f = formas(t), i;
  for (i = 0; i < f.p.length; i++) if (idx.indexOf(' ' + f.p[i]) !== -1) return true;
  for (i = 0; i < f.s.length; i++) if (idx.indexOf(' ' + f.s[i] + ' ') !== -1) return true;
  return false;
}

function cartoes() { return document.querySelectorAll('a.dv-card'); }
function visivelPelaGrade(c) {
  return !c.hasAttribute('data-dv2-oculto') && !c.hasAttribute('data-dv2-sem') && !c.hasAttribute('data-dv2-mod-fora');
}

/* ---------- a busca passa a valer na linha inteira ---------- */
function chipTodas() {
  var cs = document.querySelectorAll('.dv-chip'), i, k;
  for (i = 0; i < cs.length; i++) {
    k = cs[i].getAttribute('data-dv-key');
    if (k !== null && !k.replace(/[^a-z0-9]+/gi, '')) return cs[i];
  }
  for (i = 0; i < cs.length; i++) if (pad(cs[i].textContent).indexOf('todas') === 0) return cs[i];
  return null;
}
function aceso(el) {
  return !!el && (el.classList.contains('on') || el.classList.contains('dv-on') ||
    el.getAttribute('aria-pressed') === 'true' || el.getAttribute('data-dv-on') === '1');
}
function abreTudo() {
  var t = chipTodas();
  if (t && !aceso(t)) {
    /* o clique no atalho e o jeito honesto: a barra mostra "Todas" acesa e o
       estado interno do filtro de estilo fica certo. Guardamos a rolagem
       porque o filtro leva a pessoa para o alto da grade, e no meio de uma
       digitacao isso seria um susto. */
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    try { t.click(); } catch (e) {}
    window.scrollTo(0, y);
    setTimeout(function () { window.scrollTo(0, y); }, 0);
  }
  /* rede de seguranca: se o atalho nao existir ou nao responder, os cartoes
     escondidos pelo estilo voltam na mao. Estilo e o unico filtro que usa
     `hidden`, entao nada mais e desfeito aqui. */
  var cs = cartoes();
  for (var i = 0; i < cs.length; i++) if (cs[i].hidden) cs[i].hidden = false;
}

/* ---------- posicao e cor pedidas por escrito ---------- */
var PED = { loc: null, cor: null };
function aplicaPedido() {
  var api = window.DVRV2;
  if (!api || !api.pecas || (!PED.loc && !PED.cor)) return;
  var mexeu = false;
  api.pecas.forEach(function (it) {
    if (PED.loc && it.st.loc !== PED.loc) { it.st.loc = PED.loc; it.tocado = 1; mexeu = true; }
    if (PED.cor && it.st.cor !== PED.cor) { it.st.cor = PED.cor; it.tocado = 1; mexeu = true; }
  });
  if (mexeu && api.pintaTudo) api.pintaTudo();
}

/* o motor so observa mudanca de ESTRUTURA, nao de atributo: sem um empurrao
   ele nao monta a camiseta do cartao que a busca acabou de revelar, e o
   cartao fica em branco. Uma marca invisivel entra e sai do documento so para
   acordar o ciclo dele. */
function acorda() {
  try {
    var m = document.createComment('dvr-busca');
    document.body.appendChild(m);
    setTimeout(function () { if (m.parentNode) m.parentNode.removeChild(m); }, 0);
  } catch (e) {}
  setTimeout(aplicaPedido, 120);
  setTimeout(aplicaPedido, 700);
  setTimeout(aplicaPedido, 1700);
}

function contaAgora() {
  var el = document.querySelector('[data-dv-conta]');
  if (!el) return;
  var cs = cartoes(), n = 0;
  for (var i = 0; i < cs.length; i++) {
    var c = cs[i];
    if (c.hidden || c.hasAttribute('data-dv2-fora')) continue;
    if (!visivelPelaGrade(c)) continue;
    n++;
  }
  el.textContent = n + (n === 1 ? ' estampa' : ' estampas');
}

function estilo() {
  if (document.getElementById('dvrb-css')) return;
  var s = document.createElement('style');
  s.id = 'dvrb-css';
  s.textContent = 'a.dv-card[data-dv2-fora]{display:none !important}' +
    '.dv2-busca input{width:214px}' +
    '.dv2-busca input:focus{width:248px}' +
    '@media (max-width:699px){.dv2-busca input{width:138px}.dv2-busca input:focus{width:164px}}';
  document.head.appendChild(s);
}

/* ---------- o filtro ---------- */
function filtra(campo, caixa) {
  estilo();
  var tokens = fatia(campo.value);
  var i, t;

  /* 1. o que nao filtra nada sai fora */
  var limpos = [];
  for (i = 0; i < tokens.length; i++) if (!VAZIAS[tokens[i]]) limpos.push(tokens[i]);

  if (!limpos.length) {
    PED.loc = null; PED.cor = null;
    caixa.classList.remove('tem');
    var cs0 = cartoes();
    for (i = 0; i < cs0.length; i++) cs0[i].removeAttribute('data-dv2-fora');
    contaAgora(); acorda();
    return;
  }
  caixa.classList.add('tem');

  /* a busca passa a valer na linha inteira, nao so na colecao acesa */
  abreTudo();

  var todos = cartoes();
  var idx = [];
  for (i = 0; i < todos.length; i++) idx.push(indiceDe(todos[i]));

  /* 2. posicao e cor: palavra que nenhuma estampa tem no nome vira acao */
  var palavras = [];
  PED.loc = null; PED.cor = null;
  for (i = 0; i < limpos.length; i++) {
    t = limpos[i];
    var noNome = false;
    for (var j = 0; j < idx.length; j++) { if (bate(idx[j], t)) { noNome = true; break; } }
    if (!noNome && POS[t]) { PED.loc = POS[t]; continue; }
    if (!noNome && COR[t]) { PED.cor = COR[t]; continue; }
    palavras.push(t);
  }

  /* 3. todas as palavras que sobraram tem que bater, em qualquer ordem */
  for (i = 0; i < todos.length; i++) {
    var ok = true;
    for (var k = 0; k < palavras.length; k++) {
      if (!bate(idx[i], palavras[k])) { ok = false; break; }
    }
    if (ok) todos[i].removeAttribute('data-dv2-fora');
    else todos[i].setAttribute('data-dv2-fora', '1');
  }

  contaAgora();
  acorda();
}

/* ---------- toma conta da caixa que o motor desenhou ---------- */
function assume() {
  var caixa = document.querySelector('.dv2-busca');
  if (!caixa || caixa.dvrbPronto) return !!caixa;
  var campo0 = caixa.querySelector('input');
  if (!campo0) return false;
  caixa.dvrbPronto = 1;

  /* trocar o campo por uma copia desliga os ouvintes do motor sem apagar uma
     linha dele: a funcao antiga continua no arquivo, so nao tem mais em que
     elemento escutar. O mesmo vale para o X de limpar. */
  var campo = campo0.cloneNode(true);
  campo.setAttribute('placeholder', 'o que quer na estampa? gato, floresta, peito');
  campo0.parentNode.replaceChild(campo, campo0);

  var x0 = caixa.querySelector('.dv2-limpa'), limpa = null;
  if (x0) { limpa = x0.cloneNode(true); x0.parentNode.replaceChild(limpa, x0); }

  var espera;
  campo.addEventListener('input', function () {
    clearTimeout(espera);
    espera = setTimeout(function () { filtra(campo, caixa); }, 150);
  });
  campo.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { campo.value = ''; filtra(campo, caixa); }
    if (e.key === 'Enter') { e.preventDefault(); clearTimeout(espera); filtra(campo, caixa); }
  });
  if (limpa) limpa.addEventListener('click', function () {
    campo.value = ''; filtra(campo, caixa); campo.focus();
  });

  /* ?busca=gato no endereco ja abre a pagina filtrada: serve para anuncio e
     para link interno de SEO ("camiseta de gato" cai na grade de gatos). */
  var q = (location.search.match(/[?&]busca=([^&]*)/) || [])[1];
  if (q) {
    try { campo.value = decodeURIComponent(q.split('+').join(' ')); } catch (e) { campo.value = q; }
    setTimeout(function () { filtra(campo, caixa); }, 300);
  }
  return true;
}

var tentou = 0;
var relogio = setInterval(function () {
  tentou++;
  if (assume() || tentou > 60) clearInterval(relogio);
}, 250);
assume();
})();
